/* tslint:disable */
/* eslint-disable */
export enum CatalogEntryType {
  Composite = 'COMPOSITE',
  ProductGroup = 'PRODUCT_GROUP',
  Product = 'PRODUCT',
  ModifierGroup = 'MODIFIER_GROUP',
  Modifier = 'MODIFIER',
  Instruction = 'INSTRUCTION'
}
